"use client"

import Cookies from "js-cookie"
import { captureClientException } from "@/services/logging/capture-client-exception"

export function getSessionData() {
  const sessionCookie = Cookies.get("user-session")
  if (!sessionCookie) {
    return null
  }

  try {
    return JSON.parse(sessionCookie)
  } catch (error) {
    captureClientException(error)
    return null
  }
}
